/**
 * Route Mapping Utility
 * Maps sidebar menu paths to actual working routes in App.js
 * Prevents "Coming Soon" screens when clicking Firebase-saved menu items
 * Updated v4.0 - Full FoodBeverageModule route alignment
 */

// Map sidebar manager paths to actual working routes in App.js
// FoodBeverageModule is served under /sectors/food-beverage/* in App.js
// All paths inside FoodBeverageModule are relative (e.g. /pos/quick-sales)
// Full URL becomes /sectors/food-beverage/pos/quick-sales
const ROUTE_MAPPING = {
  // ===== ADMIN ROUTES =====
  '/dashboard/admin': '/dashboard/admin/',
  '/dashboard/admin/': '/dashboard/admin/',
  '/dashboard/admin/dashboard': '/dashboard/admin/',
  '/dashboard/admin/users': '/dashboard/admin/users',
  '/dashboard/admin/system-users': '/dashboard/admin/system-users',
  '/dashboard/admin/roles': '/dashboard/admin/roles',
  '/dashboard/admin/reports': '/dashboard/admin/reports',
  '/dashboard/admin/settings': '/dashboard/admin/settings',
  '/dashboard/admin/profile': '/dashboard/admin/profile',
  '/dashboard/admin/api-requests': '/dashboard/admin/api-requests',
  '/dashboard/admin/security': '/dashboard/admin/security',
  '/dashboard/admin/billing': '/dashboard/admin/billing',
  '/dashboard/admin/subscription': '/dashboard/admin/subscription',
  '/dashboard/admin/file-manager': '/dashboard/admin/file-manager',
  '/dashboard/admin/sidebar-manager': '/dashboard/admin/sidebar-manager',
  '/dashboard/admin/sectors': '/dashboard/admin/sectors',
  '/dashboard/admin/performance': '/dashboard/admin/performance',
  '/dashboard/admin/support': '/dashboard/admin/support',
  '/dashboard/admin/notifications': '/dashboard/admin/notifications',
  '/dashboard/admin/page-registry': '/dashboard/admin/page-registry',
  '/dashboard/admin/domain-management': '/dashboard/admin/domain-management',
  '/dashboard/admin/business-overview': '/dashboard/admin/business-overview',
  '/dashboard/admin/packages': '/dashboard/admin/packages',
  '/dashboard/admin/modules': '/dashboard/admin/modules',

  // Admin WhatsApp routes
  '/dashboard/admin/whatsapp': '/dashboard/admin/whatsapp',
  '/dashboard/admin/whatsapp/analytics': '/dashboard/admin/whatsapp/analytics',
  '/dashboard/admin/whatsapp/integrations': '/dashboard/admin/whatsapp/integrations',
  '/dashboard/admin/whatsapp/settings': '/dashboard/admin/whatsapp/settings',

  // ===== BUSINESS DASHBOARD ROUTES =====
  '/dashboard': '/sectors/food-beverage/dashboard',
  '/dashboard/personal': '/dashboard/personal',
  '/brands': '/brands',
  '/brand-catalog': '/brand-catalog',
  '/business-overview': '/business-overview',
  '/financial-status': '/financial-status',
  '/business/settings': '/business/settings',
  '/subscription/unified': '/subscription/unified',
  '/business/settings-dashboard': '/business/settings-dashboard',
  '/business/analytics-dashboard': '/business/analytics-dashboard',
  '/business/user-management-dashboard': '/business/user-management-dashboard',

  // ===== FOOD & BEVERAGE SECTOR =====
  // Base dashboard
  '/sectors/food-beverage': '/sectors/food-beverage/dashboard',
  '/sectors/food-beverage/dashboard': '/sectors/food-beverage/dashboard',
  '/sectors/restaurant': '/sectors/food-beverage/dashboard',
  '/sectors/restaurant/dashboard': '/sectors/food-beverage/dashboard',

  // POS & Sales (pos_basic)
  '/sectors/food-beverage/pos/quick-sales': '/sectors/food-beverage/pos/quick-sales',
  '/sectors/food-beverage/pos/table-service': '/sectors/food-beverage/pos/table-service',
  '/sectors/food-beverage/pos/tables': '/sectors/food-beverage/pos/tables',
  '/sectors/food-beverage/pos/phone-orders': '/sectors/food-beverage/pos/phone-orders',
  '/sectors/food-beverage/pos/qr-order-management': '/sectors/food-beverage/pos/qr-order-management',
  '/sectors/food-beverage/pos/weight-sales': '/sectors/food-beverage/pos/weight-sales',
  '/sectors/food-beverage/pos/kiosk': '/sectors/food-beverage/pos/kiosk',

  // Operations / Stock (stock_basic)
  '/sectors/food-beverage/operations/inventory-management': '/sectors/food-beverage/operations/inventory-management',
  '/sectors/food-beverage/operations/stock-movements': '/sectors/food-beverage/operations/stock-movements',
  '/sectors/food-beverage/operations/quick-stock-entry': '/sectors/food-beverage/operations/quick-stock-entry',
  '/sectors/food-beverage/operations/distribution': '/sectors/food-beverage/operations/distribution',
  '/sectors/food-beverage/operations/production-planning': '/sectors/food-beverage/operations/production-planning',
  '/sectors/food-beverage/operations/label-printing': '/sectors/food-beverage/operations/label-printing',
  '/sectors/food-beverage/operations/batch-cost-planning': '/sectors/food-beverage/operations/batch-cost-planning',
  '/sectors/food-beverage/operations/monthly-stock-entry': '/sectors/food-beverage/operations/monthly-stock-entry',
  '/sectors/food-beverage/operations/order-center': '/sectors/food-beverage/operations/order-center',
  '/sectors/food-beverage/operations/order-tracking': '/sectors/food-beverage/operations/order-tracking',
  '/sectors/food-beverage/operations/platform-management': '/sectors/food-beverage/operations/platform-management',
  '/sectors/food-beverage/warehouse-management': '/sectors/food-beverage/warehouse-management',

  // Inventory (stock_pro)
  '/sectors/food-beverage/inventory/movements': '/sectors/food-beverage/inventory/movements',
  '/sectors/food-beverage/inventory/suppliers': '/sectors/food-beverage/inventory/suppliers',

  // Finance / Accounting (accounting)
  '/sectors/food-beverage/finance/income-analysis': '/sectors/food-beverage/finance/income-analysis',
  '/sectors/food-beverage/finance/expense-management': '/sectors/food-beverage/finance/expense-management',
  '/sectors/food-beverage/finance/cash-register-tracking': '/sectors/food-beverage/finance/cash-register-tracking',
  '/sectors/food-beverage/finance/profit-loss-tracking': '/sectors/food-beverage/finance/profit-loss-tracking',
  '/sectors/food-beverage/finance/revenue-analysis': '/sectors/food-beverage/finance/revenue-analysis',
  '/sectors/food-beverage/finance/suppliers': '/sectors/food-beverage/finance/suppliers',
  '/sectors/food-beverage/finance/tax-management': '/sectors/food-beverage/finance/tax-management',
  '/sectors/food-beverage/finance/z-report': '/sectors/food-beverage/finance/z-report',
  '/sectors/food-beverage/finance/daily-sales-and-stock': '/sectors/food-beverage/finance/daily-sales-and-stock',
  '/sectors/food-beverage/finance/detailed-product-profitability': '/sectors/food-beverage/finance/detailed-product-profitability',
  '/sectors/food-beverage/finance/transaction-details': '/sectors/food-beverage/finance/transaction-details',

  // Reports & Analytics (reporting_basic / reporting_advanced)
  '/sectors/food-beverage/reports': '/sectors/food-beverage/reports',
  '/sectors/food-beverage/reports/dashboard': '/sectors/food-beverage/reports/dashboard',
  '/sectors/food-beverage/reports/analytics': '/sectors/food-beverage/reports/analytics',
  '/sectors/food-beverage/reports/platform-orders': '/sectors/food-beverage/reports/platform-orders',
  '/sectors/food-beverage/reports/web-traffic': '/sectors/food-beverage/reports/web-traffic',
  '/sectors/food-beverage/analytics': '/sectors/food-beverage/analytics',
  '/sectors/food-beverage/analytics/reports': '/sectors/food-beverage/analytics/reports',
  '/sectors/food-beverage/analytics/custom-dashboards': '/sectors/food-beverage/analytics/custom-dashboards',

  // Customers / CRM (crm)
  '/sectors/food-beverage/customers/customer-management': '/sectors/food-beverage/customers/customer-management',
  '/sectors/food-beverage/customers/customer-relationship-management': '/sectors/food-beverage/customers/customer-relationship-management',
  '/sectors/food-beverage/customers/reviews': '/sectors/food-beverage/customers/reviews',

  // Kitchen / KDS (kitchen_display)
  '/sectors/food-beverage/kitchen/kitchen-screen': '/sectors/food-beverage/kitchen/kitchen-screen',

  // Reservations
  '/sectors/food-beverage/reservations': '/sectors/food-beverage/reservations',

  // HR (hr_management)
  '/sectors/food-beverage/hr/staff-management': '/sectors/food-beverage/hr/staff-management',
  '/sectors/food-beverage/hr/performance': '/sectors/food-beverage/hr/performance',

  // Menu & QR (qr_menu)
  '/sectors/food-beverage/pages/settings/MenuManagement': '/sectors/food-beverage/pages/settings/MenuManagement',
  '/sectors/food-beverage/menu/qr-menu-generator': '/sectors/food-beverage/menu/qr-menu-generator',
  '/menu/management': '/sectors/food-beverage/pages/settings/MenuManagement',

  // Settings (core_access)
  '/sectors/food-beverage/settings': '/sectors/food-beverage/settings',
  '/sectors/food-beverage/settings/dashboard': '/sectors/food-beverage/settings',
  '/sectors/food-beverage/settings/business': '/sectors/food-beverage/settings/business',
  '/sectors/food-beverage/settings/business-settings': '/sectors/food-beverage/settings/business-settings',
  '/sectors/food-beverage/settings/pos-settings': '/sectors/food-beverage/settings/pos-settings',
  '/sectors/food-beverage/settings/table-management': '/sectors/food-beverage/settings/table-management',
  '/sectors/food-beverage/settings/kitchen-settings': '/sectors/food-beverage/settings/kitchen-settings',
  '/sectors/food-beverage/settings/financial-settings': '/sectors/food-beverage/settings/financial-settings',
  '/sectors/food-beverage/settings/user-management': '/sectors/food-beverage/settings/user-management',
  '/sectors/food-beverage/settings/delivery-settings': '/sectors/food-beverage/settings/delivery-settings',
  '/sectors/food-beverage/settings/integrations': '/sectors/food-beverage/settings/integrations',
  '/sectors/food-beverage/settings/inventory-settings': '/sectors/food-beverage/settings/inventory-settings',
  '/sectors/food-beverage/settings/printer-settings': '/sectors/food-beverage/settings/printer-settings',
  '/sectors/food-beverage/settings/app-popup': '/sectors/food-beverage/settings/app-popup',
  '/sectors/food-beverage/settings/data-backups': '/sectors/food-beverage/settings/data-backups',
  '/settings/data-backups': '/sectors/food-beverage/settings/data-backups',
  '/settings/app-popup': '/sectors/food-beverage/settings/app-popup',
  '/sectors/food-beverage/settings/api': '/sectors/food-beverage/settings/api',
  '/settings/dashboard': '/sectors/food-beverage/settings',

  // Campaigns (crm_plus / sms)
  '/sectors/food-beverage/campaigns/campaign-management': '/sectors/food-beverage/campaigns/campaign-management',
  '/integrations/campaigns': '/sectors/food-beverage/campaigns/campaign-management',

  // Social media (social_media)
  '/social-media': '/social-media',
  '/social-media/new': '/social-media/new',
  '/content-calendar': '/social-media',

  // WhatsApp (whatsapp_integration) - /business/* routes in App.js
  '/business/whatsapp': '/business/whatsapp',
  '/business/whatsapp/conversations': '/business/whatsapp',
  '/business/whatsapp/orders': '/business/whatsapp',

  // Notifications
  '/notifications': '/notifications',

  // Multi-branch
  '/business/branches': '/dashboard/personal',

  // QR Analytics alias
  '/reports/qr-analytics': '/sectors/food-beverage/reports/dashboard',

  // Legacy /sectors/restaurant/* -> /sectors/food-beverage/*
  '/sectors/restaurant': '/sectors/food-beverage/dashboard',
  '/sectors/restaurant/dashboard': '/sectors/food-beverage/dashboard',
  '/sectors/restaurant/pos/dashboard': '/sectors/food-beverage/dashboard',
  '/sectors/restaurant/pos/tables': '/sectors/food-beverage/pos/tables',
  '/sectors/restaurant/pos/table-service': '/sectors/food-beverage/pos/table-service',
  '/sectors/restaurant/pos/quick-sales': '/sectors/food-beverage/pos/quick-sales',
  '/sectors/restaurant/pos/phone-orders': '/sectors/food-beverage/pos/phone-orders',
  '/sectors/restaurant/pos/kiosk': '/sectors/food-beverage/pos/kiosk',
  '/sectors/restaurant/pos/weight-sales': '/sectors/food-beverage/pos/weight-sales',
  '/sectors/restaurant/pos/qr-order-management': '/sectors/food-beverage/pos/qr-order-management',
  '/sectors/restaurant/kitchen/kitchen-screen': '/sectors/food-beverage/kitchen/kitchen-screen',
  '/sectors/restaurant/operations/inventory-management': '/sectors/food-beverage/operations/inventory-management',
  '/sectors/restaurant/operations/order-center': '/sectors/food-beverage/operations/order-center',
  '/sectors/restaurant/operations/order-tracking': '/sectors/food-beverage/operations/order-tracking',
  '/sectors/restaurant/finance/income-analysis': '/sectors/food-beverage/finance/income-analysis',
  '/sectors/restaurant/finance/expense-management': '/sectors/food-beverage/finance/expense-management',
  '/sectors/restaurant/finance/cash-register-tracking': '/sectors/food-beverage/finance/cash-register-tracking',
  '/sectors/restaurant/finance/tax-management': '/sectors/food-beverage/finance/tax-management',
  '/sectors/restaurant/settings/table-management': '/sectors/food-beverage/settings/table-management',
  '/sectors/restaurant/settings/business-settings': '/sectors/food-beverage/settings/business-settings',
  '/sectors/restaurant/settings/user-management': '/sectors/food-beverage/settings/user-management',
  '/sectors/restaurant/customers/customer-management': '/sectors/food-beverage/customers/customer-management',
  '/sectors/restaurant/hr/staff-management': '/sectors/food-beverage/hr/staff-management',
  '/sectors/restaurant/hr/performance': '/sectors/food-beverage/hr/performance',
  '/sectors/restaurant/reports': '/sectors/food-beverage/reports',
  '/sectors/restaurant/reports/dashboard': '/sectors/food-beverage/reports/dashboard',
  '/sectors/restaurant/reports/analytics': '/sectors/food-beverage/reports/analytics',

  // ===== HOSPITALITY (OTELCILIK) SECTOR =====
  '/sectors/service/hospitality/dashboard': '/sectors/service/hospitality/dashboard',
  '/sectors/service/hospitality/rooms': '/sectors/service/hospitality/rooms',
  '/sectors/service/hospitality/rooms/availability': '/sectors/service/hospitality/rooms/availability',
  '/sectors/service/hospitality/reservations': '/sectors/service/hospitality/reservations',
  '/sectors/service/hospitality/reservations/calendar': '/sectors/service/hospitality/reservations/calendar',
  '/sectors/service/hospitality/reservations/checkin': '/sectors/service/hospitality/reservations/checkin',
  '/sectors/service/hospitality/guests': '/sectors/service/hospitality/guests',
  '/sectors/service/hospitality/guests/documents': '/sectors/service/hospitality/guests/documents',
  '/sectors/service/hospitality/guests/reviews': '/sectors/service/hospitality/guests/reviews',
  '/sectors/service/hospitality/campaigns': '/sectors/service/hospitality/campaigns',
  '/sectors/service/hospitality/campaigns/campaign-management': '/sectors/service/hospitality/campaigns/campaign-management',
  '/sectors/service/hospitality/finance': '/sectors/service/hospitality/finance',
  '/sectors/service/hospitality/finance/occupancy': '/sectors/service/hospitality/finance/occupancy',
  '/sectors/service/hospitality/finance/income': '/sectors/service/hospitality/finance/income',
  '/sectors/service/hospitality/finance/expenses': '/sectors/service/hospitality/finance/expenses',
  '/sectors/service/hospitality/reports/dashboard': '/sectors/service/hospitality/reports/dashboard',
  '/sectors/service/hospitality/hr/staff-management': '/sectors/service/hospitality/hr/staff-management',
  '/sectors/service/hospitality/settings': '/sectors/service/hospitality/settings',
  '/sectors/service/hospitality/settings/website': '/sectors/service/hospitality/settings/website',
  '/sectors/service/hospitality/settings/translations': '/sectors/service/hospitality/settings/translations',

  // Short aliases (used by App.js redirect handlers)
  '/pos/tables': '/sectors/food-beverage/pos/tables',
  '/pos/quick-sales': '/sectors/food-beverage/pos/quick-sales',
  '/pos/phone-orders': '/sectors/food-beverage/pos/phone-orders',
  '/finance/income-analysis': '/sectors/food-beverage/finance/income-analysis',
  '/kitchen/kitchen-screen': '/sectors/food-beverage/kitchen/kitchen-screen',
  '/operations/order-center': '/sectors/food-beverage/operations/order-center',
  '/operations/order-tracking': '/sectors/food-beverage/operations/order-tracking',
  '/settings/table-management': '/sectors/food-beverage/settings/table-management',
  '/reservations': '/sectors/food-beverage/reservations',
};

/**
 * Get the actual working route for a given path
 * @param {string} path - The path from sidebar configuration
 * @returns {string} - The mapped route or original path if no mapping exists
 */
export const getWorkingRoute = (path) => {
  if (!path) return '/';

  let workingPath = path;

  // Fix: Firebase'de '/admin/*' olarak kaydedilen path'leri '/dashboard/admin/*' yap
  if (workingPath === '/admin' || workingPath.startsWith('/admin/')) {
    workingPath = '/dashboard' + workingPath;
  }

  // 🚀 Normalize legacy /sectors/restaurant/ routes to /sectors/food-beverage/
  if (workingPath.startsWith('/sectors/restaurant')) {
    workingPath = workingPath.replace('/sectors/restaurant', '/sectors/food-beverage');
  }

  // Direct mapping check
  if (ROUTE_MAPPING[workingPath]) {
    return ROUTE_MAPPING[workingPath];
  }

  // Business Detail dynamic route
  if (workingPath.match(/^\/business\/[^/]+\/detail$/)) {
    return workingPath;
  }

  // If already a valid path, return as-is
  if (workingPath.startsWith('/sectors/')) {
    return workingPath;
  }

  // If no mapping found, return original.
  // App.js RedirectHandler will catch /pos/*, /finance/* etc.
  return path;
};

/**
 * Check if a route exists and is not a "Coming Soon" page
 * @param {string} path - The path to check
 * @returns {boolean} - True if route exists and is functional
 */
export const isWorkingRoute = (path) => {
  const workingRoute = getWorkingRoute(path);

  const knownPrefixes = [
    '/sectors/food-beverage/',
    '/sectors/restaurant/',
    '/sectors/service/',
    '/sectors/retail/',
    '/hospitality/',
    '/dashboard/admin/',
    '/dashboard',
    '/brands',
    '/business',
    '/social-media',
    '/notifications'
  ];

  return knownPrefixes.some(prefix => workingRoute.startsWith(prefix));
};

/**
 * Get user-friendly label for a route
 */
export const getRouteLabel = (path) => {
  const labels = {
    '/dashboard': 'Dashboard',
    '/sectors/food-beverage/dashboard': 'Dashboard',
    '/sectors/food-beverage/operations/inventory-management': 'Envanter Yönetimi',
    '/sectors/food-beverage/reports': 'Raporlar',
  };
  return labels[path] || path.split('/').pop() || 'Sayfa';
};

const routeUtils = {
  getWorkingRoute,
  isWorkingRoute,
  getRouteLabel,
  ROUTE_MAPPING
};

export default routeUtils;